import React from "react";

import type { ClientId } from "../../domain/types";
import { updateClient, useCoClient } from "../../data/store";
import { SubStepShell } from "../../components/SubStepShell";
import { useSubStepNav } from "../useSubStepNav";

export function AccountStartDateStep({ clientId }: { clientId: ClientId }) {
  const client = useCoClient(clientId);
  const { goNext } = useSubStepNav(clientId, "account-start-date");

  if (!client) return null;

  return (
    <SubStepShell
      title="Start date"
      description="The first date Zournal treats the books as current - everything before this date is opening balances, not transactions."
      thenWhat="Continue → we'll keep connecting this client's books."
      onContinue={() => void goNext()}
      continueDisabled={!client.accountStartDate}
    >
      <p className="text-sm text-muted-foreground">
        From the Account Start Date, Zournal will begin accounting for this client. The Client Dashboard and all
        reports will also show data starting from this date.
      </p>

      <label className="flex max-w-xs flex-col gap-1 text-sm">
        <span className="text-xs font-medium text-muted-foreground">Account start date</span>
        <input
          type="date"
          value={client.accountStartDate}
          onChange={(event) => updateClient(clientId, { accountStartDate: event.target.value })}
          className="h-9 rounded-md border bg-background px-2 text-sm"
        />
      </label>
    </SubStepShell>
  );
}
